import { observer } from 'mobx-react';
import React, { useMemo, useState } from 'react';

import { useStores } from '../../../../../hooks';
import { format_price } from '../../../../../js/utils';
import { Counter } from '../../../../Counter/';
import { SelectCustom } from '../../../../SelectCustom';
import { makeSelectOption } from '../../utils';

import styles from './styles/gift_item.module.scss';

export const GiftItem = observer(({ gift }) => {
  const [selectedOption, setSelectedOption] = useState(
    makeSelectOption(gift.nominals[0]),
  );
  const [count, setCount] = useState(1);

  const { modalStore } = useStores();

  const nominalOptions = useMemo(
    () => gift.nominals.map((el) => makeSelectOption(el)),
    [gift],
  );

  const handleOpenModal = () => {
    modalStore.open('getGift', {
      count,
      nominal: selectedOption,
      gift,
    });
  };

  const handleSelectOption = (option) => {
    setSelectedOption(option);
  };

  return (
    <div className={styles.gift}>
      <img loading="lazy" src={gift.image} alt={gift.title} className={styles.gift__image} />
      <p className={styles.gift__name}>{gift.title}</p>
      <div className={styles.gift__inputs}>
        <div className={styles.gift__label}>
          <span>Номинал</span>
          <SelectCustom
            options={nominalOptions}
            onChange={handleSelectOption}
            value={selectedOption}
            selectCustomStyles={{ maxWidth: '100%' }}
          />
        </div>
        <div className={styles.gift__label}>
          <span>Количество</span>
          <Counter value={count} name="count" onChange={setCount} max={999} />
        </div>
      </div>
      <div className={styles.gift__label}>
        <span>Цена за шт.</span>
        <span className={styles.gift__price}>
          {format_price(selectedOption.price)} ₽
        </span>
      </div>
      <button className={styles.gift__button} onClick={handleOpenModal}>
        Получить подарок
      </button>
    </div>
  );
});
